import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { auth } from "@/lib/api";

const TIMEOUT_MS = 15 * 60 * 1000; // 15 min
const WARNING_MS = 14 * 60 * 1000;

/** Auto-logout after 15 minutes of inactivity. */
export default function useIdleLogout() {
  const navigate = useNavigate();
  const t = useRef(null);
  const w = useRef(null);

  useEffect(() => {
    const reset = () => {
      if (t.current) clearTimeout(t.current);
      if (w.current) clearTimeout(w.current);
      w.current = setTimeout(() => {
        toast.warning("Session expiring in 1 minute due to inactivity");
      }, WARNING_MS);
      t.current = setTimeout(() => {
        auth.logout();
        toast.error("Session expired due to inactivity");
        navigate("/login");
      }, TIMEOUT_MS);
    };
    const events = ["mousemove", "keydown", "click", "scroll", "touchstart"];
    events.forEach(e => window.addEventListener(e, reset, { passive: true }));
    reset();
    return () => {
      events.forEach(e => window.removeEventListener(e, reset));
      if (t.current) clearTimeout(t.current);
      if (w.current) clearTimeout(w.current);
    };
  }, [navigate]);
}
